<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_598_1664)">
      <path
        d="M28.3316 20.9748C28.7097 20.0049 28.2256 18.902 27.2557 18.5238L7.46972 10.8096C7.37273 10.7718 5.36209 6.94059 5.36209 6.94059L3.59863 6.25305L3.06313 10.1276C2.46623 10.1996 2.01385 10.3178 1.83165 10.7851C1.28849 12.1783 4.31893 13.6543 5.20947 14.0016L12.6512 16.903L11.6199 19.5482L7.03557 23.8553L9.55731 24.8385L16.0286 21.267L18.7616 19.2853L25.8771 22.0595C26.847 22.4377 27.95 21.9535 28.3281 20.9836L28.3316 20.9748Z"
        fill="#8ED5E3"
      />
      <path
        d="M9.61126 25.6112L5.73166 24.0986L11.0203 19.1315L11.7353 17.2975L4.95482 14.6539C4.47868 14.4682 0.296912 12.7667 1.17353 10.5183C1.42448 9.87466 1.96176 9.61689 2.43178 9.50557L3.01855 5.26501L5.86653 6.37539L5.98982 6.6063C6.76374 8.08632 7.64092 9.71833 7.9389 10.2306L27.5132 17.8624C28.8535 18.3849 29.5151 19.8923 28.9926 21.2325C28.4701 22.5727 26.9627 23.2344 25.6225 22.7119L18.8685 20.0786L16.4463 21.8361L9.61126 25.6112V25.6112ZM8.34582 23.5941L9.5097 24.0479L15.6942 20.6389L18.6699 18.4775L26.147 21.3927C26.7554 21.6299 27.4416 21.3287 27.6788 20.7203C27.916 20.1119 27.6148 19.4256 27.0064 19.1884L7.21163 11.4707C6.90302 11.3504 6.86775 11.3367 4.85711 7.50547L4.17818 7.24077L3.68708 10.767L3.14458 10.8297C2.55112 10.8929 2.51331 10.9899 2.49268 11.0428C2.28642 11.5718 3.95928 12.7522 5.46704 13.3401L13.5701 16.4994L12.2225 19.9557L8.34239 23.603L8.34582 23.5941Z"
        fill="#011837"
      />
      <path
        d="M19.7793 13.5979L18.4705 13.047L18.7597 12.3573L17.7112 5.40701L16.3181 4.86385L15.7213 10.9797L15.3776 11.8614L14.055 11.3458L14.3644 10.5522L15.0879 2.8606L18.9851 4.38006L20.2217 12.5413L19.7793 13.5979Z"
        fill="#011837"
      />
    </g>
    <defs>
      <clipPath id="clip0_598_1664">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
